import React, { FC, ReactNode } from 'react';

import { Container } from '../Container';
import Search from '../Search';
import { useAdminPermissions } from 'src/hooks/useAdminPermissions';

import { HeaderActions, HeaderControls, HeaderTitle, StyledHeader } from './styled';

const PageHeader: FC<{
  title: string;
  subtitle?: string;
  dropdownTitle?: string;
  dropDownItems?: string[];
  hideSearch?: boolean;
  children?: ReactNode;
  /** Extra controls rendered next to search (e.g. Add button). */
  headerActions?: ReactNode;
  entity?: string;
  updateEntityField?: any;
  updateEntitySearch?: any;
  /** Predefined values per search field; see Search's own prop. */
  valueOptions?: Record<string, { value: string; label: string }[]>;
}> = ({
  title,
  subtitle,
  dropdownTitle,
  dropDownItems,
  hideSearch,
  children,
  headerActions,
  entity,
  updateEntityField,
  updateEntitySearch,
  valueOptions,
}) => {
  const { loading: permissionsLoading, initialized } = useAdminPermissions();
  const reserveActionSlot = Boolean(headerActions) && (!initialized || permissionsLoading);
  const hasToolbar = !hideSearch || Boolean(headerActions);

  return (
    <>
      <StyledHeader $hasToolbar={hasToolbar}>
        <HeaderTitle>{title}</HeaderTitle>
        {(!hideSearch || headerActions) && (
          <HeaderControls>
            {!hideSearch && (
              <Search
                title={dropdownTitle ?? title}
                dropDownItems={dropDownItems}
                entity={entity as string}
                updateEntityField={updateEntityField}
                updateEntitySearch={updateEntitySearch}
                valueOptions={valueOptions}
                toolbar
              />
            )}
            {headerActions ? (
              <HeaderActions $reserve={reserveActionSlot}>{headerActions}</HeaderActions>
            ) : null}
          </HeaderControls>
        )}
      </StyledHeader>
      {subtitle ? (
        <Container fontSize="1rem" paddingBottom="2rem">
          {subtitle}
        </Container>
      ) : (
        children
      )}
    </>
  );
};

export default PageHeader;
